import { useEffect } from 'react';
import { useData } from '@/context/DataContext';

export default function AboutPage() {
  const { fetchContent, getContentBySection, loading } = useData();

  useEffect(() => {
    fetchContent('about');
  }, [fetchContent]);

  const werdegangContent = getContentBySection('about', 'werdegang');
  const qualifikationenContent = getContentBySection('about', 'qualifikationen');

  const werdegangItems = (werdegangContent?.content || '').split('|').filter(Boolean);
  const qualifikationenItems = (qualifikationenContent?.content || '').split('|').filter(Boolean);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div className="bg-white" data-testid="about-page">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-normal text-[#2c3e50] text-center mb-8">Über mich</h1>

        {/* Profile Section */}
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          <div className="text-center md:text-left">
            <img 
              src="https://psychotherapie-praxis-langer.de/Bilder/KatharinaLanger.jpg"
              alt="Katharina Langer"
              className="w-full max-w-sm mx-auto md:mx-0 rounded shadow-md"
            />
          </div>
          <div>
            <p className="text-[#7f8c8d] mb-2">M.Sc.-Psych.</p>
            <h2 className="text-2xl font-semibold text-[#2c3e50] mb-2">Katharina Langer</h2>
            <p className="text-[#7f8c8d] mb-6">Psychologische Psychotherapeutin</p>
            
            <p className="text-[#2c3e50] leading-relaxed">
              Wie kann ich Sie als Psychologische Psychotherapeutin unterstützen? Gerne helfe ich Ihnen bei psychischen Problemen wie z.B. Depression, Burnout, Stress, Beziehungsproblemen, Angst, Zwangsstörungen, Psychosomatischen Störungen, Chronischen Erkrankungen, Essstörungen, Suchterkrankungen, unerfülltem Kinderwunsch, Fehl- und Totgeburten, Posttraumatischen Belastungsstörungen, Trauer, Schlafstörungen.
            </p>
          </div>
        </div>

        <hr className="my-8 border-gray-300" />

        {/* Werdegang */}
        <div className="mb-12">
          <h3 className="text-xl font-semibold text-[#2c3e50] mb-4">Werdegang</h3>
          <ul className="space-y-2 text-[#2c3e50]">
            {werdegangItems.map((item, idx) => (
              <li key={idx} className="flex items-start">
                <span className="mr-2">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Qualifikationen */}
        <div>
          <h3 className="text-xl font-semibold text-[#2c3e50] mb-4">Qualifikationen</h3>
          <ul className="space-y-2 text-[#2c3e50]">
            {qualifikationenItems.map((item, idx) => (
              <li key={idx} className="flex items-start">
                <span className="mr-2">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
